import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faSignOutAlt,
  faExclamationTriangle,faUsersCog, faMoneyCheckAlt,faBookmark,faNewspaper,faStickyNote
} from '@fortawesome/free-solid-svg-icons';
import './sidestyles.css';
import logo from "../../assets/Knack Vibes (2).png";

const SuperAdminSideNavbar = ({ children }) => {
  const [sidebarActive, setSidebarActive] = useState(false);
  const [selectedItem, setSelectedItem] = useState('home');
  const navigate = useNavigate();
 
  const handleLogout = () => {
    // Clear all localStorage data
    localStorage.clear();
    // Navigate to super admin login page
    navigate("/Superadminlogin");
  };
  const handleNavigate = () => {
    navigate("/errorlogs");
  };
  const handleNavigate1 = () => {
    navigate("/listofusers");
  };

  const handleSubscribedlist = () => {
    navigate("/subscribeduserslist");
  };
  const handleuserinterestslist = () => {
    navigate("/userinterestslist");
  };
  const handlesavedpromptslist = () => {
    navigate("/savedpromptslist");
  };
  
  const handlepostslist = () => {
    navigate("/allposts");
  };
  const toggleSidebar = () => {
    setSidebarActive(!sidebarActive);
  };

 
  return (
    <div className={`wrapper ${sidebarActive ? 'sidebar-active' : ''}`}>
    <nav id="sidebar" className={sidebarActive ? 'active' : ''}>
      <div className="text-center mb-5" style={{ backgroundColor: '#2e3192' }}>
        <img src={logo} style={{ height: '108px' }} alt="Logo" />
      </div>
      <ul className="list-unstyled components">
      <li className={`dropdown ${selectedItem === 'ai' ? 'active' : ''}`}>
            <a href="#" onClick={() => handleNavigate1('/listofusers', 'listofusers')} style={{ textDecoration: "none" }}>
              <FontAwesomeIcon icon={faUsersCog} className='fa-icon' /> User's List
            </a>
          </li>
          <li className={`dropdown ${selectedItem === 'subscribeduserslist' ? 'active' : ''}`}>
            <a href="#" onClick={() => handleSubscribedlist('/subscribeduserslist', 'subscribeduserslist')} style={{ textDecoration: "none" }}>
              <FontAwesomeIcon icon={faMoneyCheckAlt} className='fa-icon' /> Subscription Details
            </a>
          </li>
          <li className={`dropdown ${selectedItem === 'userinterestslist' ? 'active' : ''}`}>
            <a href="#" onClick={() => handleuserinterestslist('/userinterestslist', 'userinterestslist')} style={{ textDecoration: "none" }}>
              <FontAwesomeIcon icon={faStickyNote} className='fa-icon' /> User Interests
            </a>
          </li>
          <li className={`dropdown ${selectedItem === 'savedpromptslist' ? 'active' : ''}`}>
            <a href="#" onClick={() => handlesavedpromptslist('/savedpromptslist', 'savedpromptslist')} style={{ textDecoration: "none" }}>
              <FontAwesomeIcon icon={faBookmark} className='fa-icon' style={{marginRight:6}} />Saved Prompts
            </a>
          </li>
          <li className={`dropdown ${selectedItem === 'allposts' ? 'active' : ''}`}>
            <a href="#" onClick={() => handlepostslist('/allposts', 'allposts')} style={{ textDecoration: "none" }}>
              <FontAwesomeIcon icon={faNewspaper} className='fa-icon' /> Posts
            </a>
          </li>
      <li className={`dropdown ${selectedItem === 'errorlogs' ? 'active' : ''}`}>
            <a href="#" onClick={() => handleNavigate('/errorlogs', 'errorlogs')} style={{ textDecoration: "none" }}>
              <FontAwesomeIcon icon={faExclamationTriangle} className='fa-icon' /> Error Logs
            </a>
          </li>
        <li className={`dropdown ${selectedItem === 'logout' ? 'active' : ''}`}>
          <a href="#" onClick={() => handleLogout()} style={{ textDecoration: "none" }}>
            <FontAwesomeIcon icon={faSignOutAlt} className='fa-icon' /> Logout
          </a>
        </li>
      </ul>
    </nav>

    <div id="content">
      <nav className="navbar navbar-expand-lg navbar-light bg-light" style={{ minHeight: '80px', height: '80px', marginTop: '8px' }}>
        <div className='container'>
      <button
            type="button"
            id="sidebarCollapse"
            style={{ backgroundColor: "#fff", borderColor: "#fff" }}
            className="btn btn-info"
            onClick={toggleSidebar}
          >
            <i className="fa fa-align-left"></i>
          </button>
          </div>
            </nav>

      <div className="container">
        {children}
      </div>
    </div>
  </div>
  );
};

export default SuperAdminSideNavbar;
